import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { getProjectDetail } from '../../services/mapService';
import ForestDetail from '../ForestDetail';
import MillDetail from '../MillDetail';
import SinglePhotoDetail from '../SinglePhotoDetail';
import PanoramaDetail from '../PanoramaDetail';
import VideoDetail from '../VideoDetail';
import DefaultLoading from '../Loading';
import Notification from '../StoraEnsoComponents/Notification';
import { ContainerWrapper, Container } from '../Container';
import Section from '../Section';
import BasicMultimediaInformation from './BasicMultimediaInformation';
import UploadRefresh from './UploadRefresh';
import ProcesssingCheck from './ProcessingCheck';
import ProcessingCheckMultimedia from './ProcessingCheckMultimedia';
import { MULTIMEDIA_TYPES } from '../../config';
import BasicDroneInformation from './BasicDroneInformation';

const Loading = styled(DefaultLoading)`
  margin: 60px auto;
  justify-content: center;
`;

const ErrorWrapper = styled.div`
  margin: 1rem auto;
  max-width: 75%;
`;

function ProjectDetailPage() {
  const [isLoading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);
  const [ projectData, setProjectData] = useState(null);
  const [ projectStatus, setProjectStatus] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    getProjectDetail(id)
      .then(data => {
        setProjectData(data);
        projectStatusSetting(data.status_name);

      })
      .catch(err => {
        setLoadingError(err);
        console.error('Cannot download project detail data.')
      })
      .then(() => setLoading(false));

  }, [id]);

  const projectStatusSetting = (status)=>{
    if (status === 'uploading') {
      setProjectStatus('uploading')
      return
    }
    if (status ==='orthoWms' || status ==='projDataDeleted') {
      setProjectStatus('processed');
      return
    }
    setProjectStatus('processing');
    return


  }
  const type = projectData?.type_desc || projectData?.location_type;

  return (
    <>
      {
        isLoading && (
        <Loading message="Loading project data..." />
      )}

      {
        loadingError && (
          <ErrorWrapper>
              <Notification kind="negative" onClose={() => setLoadingError(false)}>An error has occurred while loading project data!</Notification>
          </ErrorWrapper>
      )}

      {
        projectData && (
          <ContainerWrapper>
            <Container isFullWidth={!MULTIMEDIA_TYPES.includes(type)}>
              <Section title="Basic Information">
                {MULTIMEDIA_TYPES.includes(type) ?
                (<BasicMultimediaInformation data={projectData} type={type} />) :
                ( <BasicDroneInformation data={projectData}/>)
                }
              </Section>

              {
                MULTIMEDIA_TYPES.includes(type) && (
                  <>
                    {
                      projectData.status !== 5 ? (
                        <ProcessingCheckMultimedia />
                      ) : (
                        <>
                          {
                            type === 'single' && (
                              <SinglePhotoDetail projectData={projectData}/>
                            )
                          }

                          {
                            type === 'panorama' && (
                              <PanoramaDetail projectData={projectData}/>
                            )
                          }

                          {
                            type === 'video' && (
                              <VideoDetail projectData={projectData}/>
                            )
                          }
                        </>
                      )
                    }
                  </>
                )

              }

              {
              (type === 'forest' || type === 'forestRGB' || type === 'forestMulti' ) && (
                  <>
                    { projectStatus ==='uploading' && <UploadRefresh id={projectData.id}/> }
                    { projectStatus ==='processing' && <ProcesssingCheck id={projectData.id}/> }
                    { projectStatus ==='processed'&& <ForestDetail projectData={projectData}/>}
                  </>
                )
              }
              {
                type === 'mill' && (
                  <>
                    { projectStatus ==='uploading' && <UploadRefresh id={projectData.id}/> }
                    { projectStatus ==='processing' && <ProcesssingCheck id={projectData.id}/> }
                    { projectStatus ==='processed'&& <MillDetail projectData={projectData}/>}
                  </>
                )
              }
            </Container>
          </ContainerWrapper>
      )}
    </>
  );
}

export default ProjectDetailPage;